


























import { Vue, Component, Prop } from 'vue-property-decorator';
import TaxcardSummary from '@/views/taxcard/transaction-detail/TaxcardSummary.vue';
import QRCode from 'qrcode';
import PrintingApi from '@/app/api/PrintingApi';
import { Action, State } from 'vuex-class';
import NewTranslation from '@/components/i18n/NewTranslation.vue';
import i18next from 'i18next';
import { NamedRoutes } from '@/routes/routes';
import CommuneApi from '@/app/api/CommuneApi';

@Component({
  components: { NewTranslation, TaxcardSummary },
})
export default class HomePrinterPage extends Vue {
  @Prop(Number)
  public transactionId!: number;

  @Prop(Number)
  public communeId!: number;

  @Prop(Array)
  public taxcardIds!: number[];

  @State
  public customerUUID!: string;

  @State
  public userTransactions!: any;

  @State
  public communeSelected!: any;

  get transaction(): any {
    return (
      (this.userTransactions &&
        this.userTransactions.find((transaction: any) => transaction.id === this.transactionId)) ||
      {}
    );
  }

  get taxcards(): any[] {
    return this.transaction && this.transaction.taxcards
      ? this.transaction.taxcards.filter((taxcard: any) => this.taxcardIds.includes(taxcard.id) && !taxcard.digitalOutputBlocked)
      : [];
  }

  printCallback!: (event: Event) => void;

  qrCodes: string[] = [];
  qrCodePromises!: Promise<void>[];

  created() {
    this.qrCodePromises = this.qenerateQrCodes();
    this.printCallback = this.onAfterPrint.bind(this);
    (window as any).onprintCallback = this.onAfterPrint.bind(this);
    (window as any).parent.onprintCallback = this.onAfterPrint.bind(this);
    window.addEventListener('afterprint', this.printCallback);
  }

  mounted() {
    Promise.all(this.qrCodePromises).then(() => {
      const anyWindow = window as any;

      if (anyWindow.Printer && anyWindow.Printer.postMessage) {
        const css = `
        svg:not(:root).svg-inline--fa {
  overflow: visible;
}

.svg-inline--fa {
  display: inline-block;
  font-size: inherit;
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.225em;
}
.svg-inline--fa.fa-w-1 {
  width: 0.0625em;
}
.svg-inline--fa.fa-w-2 {
  width: 0.125em;
}
.svg-inline--fa.fa-w-3 {
  width: 0.1875em;
}
.svg-inline--fa.fa-w-4 {
  width: 0.25em;
}
.svg-inline--fa.fa-w-5 {
  width: 0.3125em;
}
.svg-inline--fa.fa-w-6 {
  width: 0.375em;
}
.svg-inline--fa.fa-w-7 {
  width: 0.4375em;
}
.svg-inline--fa.fa-w-8 {
  width: 0.5em;
}
.svg-inline--fa.fa-w-9 {
  width: 0.5625em;
}
.svg-inline--fa.fa-w-10 {
  width: 0.625em;
}
.svg-inline--fa.fa-w-11 {
  width: 0.6875em;
}
.svg-inline--fa.fa-w-12 {
  width: 0.75em;
}
.svg-inline--fa.fa-w-13 {
  width: 0.8125em;
}
.svg-inline--fa.fa-w-14 {
  width: 0.875em;
}
.svg-inline--fa.fa-w-15 {
  width: 0.9375em;
}
.svg-inline--fa.fa-w-16 {
  width: 1em;
}
.svg-inline--fa.fa-w-17 {
  width: 1.0625em;
}
.svg-inline--fa.fa-w-18 {
  width: 1.125em;
}
.svg-inline--fa.fa-w-19 {
  width: 1.1875em;
}
.svg-inline--fa.fa-w-20 {
  width: 1.25em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: 0.3em;
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: 0.3em;
  width: auto;
}
.svg-inline--fa.fa-border {
  height: 1.5em;
}
.svg-inline--fa.fa-li {
  width: 2em;
}
.svg-inline--fa.fa-fw {
  width: 1.25em;
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  -webkit-transform-origin: center center;
          transform-origin: center center;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
  -webkit-transform-origin: center center;
          transform-origin: center center;
}

.fa-layers-counter {
  background-color: #ff253a;
  border-radius: 1em;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  color: #fff;
  height: 1.5em;
  line-height: 1;
  max-width: 5em;
  min-width: 1.5em;
  overflow: hidden;
  padding: 0.25em;
  right: 0;
  text-overflow: ellipsis;
  top: 0;
  -webkit-transform: scale(0.25);
          transform: scale(0.25);
  -webkit-transform-origin: top right;
          transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: 0;
  right: 0;
  top: auto;
  -webkit-transform: scale(0.25);
          transform: scale(0.25);
  -webkit-transform-origin: bottom right;
          transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: 0;
  left: 0;
  right: auto;
  top: auto;
  -webkit-transform: scale(0.25);
          transform: scale(0.25);
  -webkit-transform-origin: bottom left;
          transform-origin: bottom left;
}

.fa-layers-top-right {
  right: 0;
  top: 0;
  -webkit-transform: scale(0.25);
          transform: scale(0.25);
  -webkit-transform-origin: top right;
          transform-origin: top right;
}

.fa-layers-top-left {
  left: 0;
  right: auto;
  top: 0;
  -webkit-transform: scale(0.25);
          transform: scale(0.25);
  -webkit-transform-origin: top left;
          transform-origin: top left;
}

.fa-lg {
  font-size: 1.3333333333em;
  line-height: 0.75em;
  vertical-align: -0.0667em;
}

.fa-xs {
  font-size: 0.75em;
}

.fa-sm {
  font-size: 0.875em;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: 2.5em;
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: -2em;
  position: absolute;
  text-align: center;
  width: 2em;
  line-height: inherit;
}

.fa-border {
  border: solid 0.08em #eee;
  border-radius: 0.1em;
  padding: 0.2em 0.25em 0.15em;
}

.fa-pull-left {
  float: left;
}

.fa-pull-right {
  float: right;
}

.fa.fa-pull-left,
.fas.fa-pull-left,
.far.fa-pull-left,
.fal.fa-pull-left,
.fab.fa-pull-left {
  margin-right: 0.3em;
}
.fa.fa-pull-right,
.fas.fa-pull-right,
.far.fa-pull-right,
.fal.fa-pull-right,
.fab.fa-pull-right {
  margin-left: 0.3em;
}

.fa-spin {
  -webkit-animation: fa-spin 2s infinite linear;
          animation: fa-spin 2s infinite linear;
}

.fa-pulse {
  -webkit-animation: fa-spin 1s infinite steps(8);
          animation: fa-spin 1s infinite steps(8);
}

@-webkit-keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}

@keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";
  -webkit-transform: rotate(90deg);
          transform: rotate(90deg);
}

.fa-rotate-180 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";
  -webkit-transform: rotate(180deg);
          transform: rotate(180deg);
}

.fa-rotate-270 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";
  -webkit-transform: rotate(270deg);
          transform: rotate(270deg);
}

.fa-flip-horizontal {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";
  -webkit-transform: scale(-1, 1);
          transform: scale(-1, 1);
}

.fa-flip-vertical {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
  -webkit-transform: scale(1, -1);
          transform: scale(1, -1);
}

.fa-flip-both, .fa-flip-horizontal.fa-flip-vertical {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
  -webkit-transform: scale(-1, -1);
          transform: scale(-1, -1);
}

:root .fa-rotate-90,
:root .fa-rotate-180,
:root .fa-rotate-270,
:root .fa-flip-horizontal,
:root .fa-flip-vertical,
:root .fa-flip-both {
  -webkit-filter: none;
          filter: none;
}

.fa-stack {
  display: inline-block;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: #fff;
}

.sr-only {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.sr-only-focusable:active, .sr-only-focusable:focus {
  clip: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  position: static;
  width: auto;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: 1;
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: 0.4;
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: 0.4;
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: 1;
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}

.fad.fa-inverse {
  color: #fff;
}
        .print-frame .print-pair {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.print-frame .ticket {
  text-align: center;
  border: 0.5mm dashed grey;
  padding-top: 1.4rem;
  padding-bottom: 1.4rem;
  height: 100%;
}
.print-frame .ticket .app-name {
  margin-bottom: 1rem;
  font-size: 1.8rem;
  font-weight: bold;
}
.print-frame .ticket .transaction-commune-title {
  margin-bottom: 1.5rem;
  font-size: 1.8rem;
}
.print-frame .ticket .transaction-commune-accepted-by {
  display: block;
  font-size: 1.2rem;
}
.print-frame table {
  width: 100%;
}
.print-frame table tr:nth-child(n+2) td .ticket {
  border-top: 0.5mm dashed grey;
}
.print-frame .ticket {
  -webkit-column-break-inside: avoid;
     -moz-column-break-inside: avoid;
          break-inside: avoid;
  width: 50%;
  height: 100%;
}

.taxcard-summary {
  margin-top: 2rem;
}
.taxcard-summary .taxcard-guest-name {
  text-align: center;
  font-size: 1.2rem;
  margin-bottom: 2rem;
}
.taxcard-summary .taxcard-id {
  text-align: center;
}
.taxcard-summary .transaction-person-count {
  display: block;
  text-align: center;
  font-size: 1.2rem;
}
.taxcard-summary .transaction-person-count > .icon {
  font-size: 22px;
  vertical-align: bottom;
  position: relative;
  color: white;
  fill: white;
  margin-right: 10px;
}
.taxcard-summary .transaction-person-count + .transaction-person-count {
  margin-top: 0.2rem;
}
.taxcard-summary .transaction-person-data {
  display: block;
  text-align: center;
  font-size: 1.2rem;
}
.taxcard-summary .transaction-person-data + .transaction-person-data {
  margin-top: 0.2rem;
}
.taxcard-summary .transaction-card-type {
  text-align: center;
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
}
.taxcard-summary .transaction-stay {
  text-align: center;
  font-size: 1.2rem;
  margin-bottom: 2rem;
}
.taxcard-summary .transaction-card-photo {
  display: block;
  margin: 0 auto 1rem;
  max-width: 90%;
  max-height: 300px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
}
.taxcard-summary .transaction-person-count + .transaction-person-data {
  margin-top: 2rem;
}
.taxcard-summary .transaction-qr-code {
  display: block;
  margin: 3rem auto 1rem;
}
.taxcard-summary .additional-info {
  text-align: center;
  padding: 0.3rem;
  font-size: 0.9em;
  font-style: italic;
}
.taxcard-summary .print-status {
  text-align: center;
  margin: 0.7rem 0;
  color: #f6b64c;
  font-size: 1.4em;
}`;

        const printFrame = document.querySelector('.print-frame');
        if (printFrame) {
          const newDoc = document.implementation.createHTMLDocument('print doc');
          newDoc.body.append(printFrame.cloneNode(true));
          const styleElement = newDoc.createElement('style');
          styleElement.innerHTML = css;
          newDoc.head.append(styleElement);
          const message = new XMLSerializer().serializeToString(newDoc);
          anyWindow.Printer.postMessage(message);
        }
        // const noscriptArea = document.getElementsByTagName('noscript');
        // const noscriptHtml = noscriptArea[0].innerText.replace(/</g, '&lt;').replace(/>/g, '&gt;');
      } else {
        setTimeout(() => window.print(), 400);
      }
    });
  }

  destroyed() {
    window.removeEventListener('afterprint', this.printCallback);
    delete (window as any).onprintCallback;
    delete (window as any).parent.onprintCallback;
  }

  qenerateQrCodes(): Promise<void>[] {
    const qrCodeOptions = { margin: 0, color: { dark: '#000000', light: '#FFFFFF' } };

    return this.taxcards.map(taxcard => {
      return QRCode.toDataURL(
        `https://web.welcmpass.info/qr/control?taxId=${taxcard.taxId}`,
        qrCodeOptions
      ).then((url: string) => this.qrCodes.push(url));
    });
  }

  onAfterPrint(event: Event) {
    // NOTE: state printed postponed; keep taxcards active
    // const ids = this.taxcards.map(taxcard => taxcard.id);
    // PrintingApi.setTaxcardsPrinted(ids, this.customerUUID);
    // this.$store.commit('openOverlay', {
    //   overlayName: 'Info',
    //   overlayData: {
    //     title: i18next.t('transaction.printOverlay.printed.title'),
    //     message: i18next.t('transaction.printOverlay.printed.message'),
    //     submit: () => {
    //       this.$router.push({ name: NamedRoutes.transactionOverview });
    //     },
    //   },
    // });
  }

  get appName() {
    return this.transaction.appName;
  }

  get communeTitle() {
    return this.transaction.communeTitle;
  }
}
